export const Urls = {
  getCategoryDetails: () => "/product/category/get",
  gerProductDetails: () => "/product/get",
  insertContactDetails: () => "/contact/add",
  getReletedProduct: () => "/reletedProduct/get",
  getMasterRelatedProduct: () => "/reletedProductmaster/get",
};
